import gql from 'graphql-tag';

import {reportsTableFragment} from './../components/ReportsTable';
import {runsTableFragment} from './../components/RunsTable';

export const PROFILE_PAGE_QUERY = gql`
  query ProfilePage($username: String!) {
    user(userName: $username) {
      id
      name
      username
      email
      photoUrl
      userInfo
      hideTeamsFromPublic
      accountType
      defaultEntity {
        id
        name
      }
      views(viewType: "runs", first: 10000) {
        edges {
          node {
            id
            ...ReportsTableFragment
          }
        }
      }
      starredViews(first: 500) {
        edges {
          node {
            id
            ...ReportsTableFragment
          }
        }
      }
      teams(first: 100) {
        edges {
          node {
            id
            name
            photoUrl
            isTeam
          }
        }
      }
    }
  }
  ${reportsTableFragment}
`;

export const PROFILE_PAGE_PROJECTS_QUERY = gql`
  query ProfilePageProjects($username: String!) {
    user(userName: $username) {
      id
      projects(first: 100) {
        edges {
          node {
            id
            name
            entityName
            access
            description
            totalRuns
            lastActive
            runCount
            user {
              id
              username
            }
          }
        }
      }
    }
  }
`;

export const USER_RUNS_ACTIVITY_QUERY = gql`
  query UserRunsActivity($username: String!, $dailyRunCountLimit: Int!) {
    user(userName: $username) {
      id
      dailyRunCount(limit: $dailyRunCountLimit)
    }
  }
`;

export const USER_RUNS_QUERY = gql`
  query UserRuns($username: String!, $pattern: String, $first: Int = 100) {
    user(userName: $username) {
      id
      runs(first: $first, pattern: $pattern) {
        edges {
          node {
            id
            ...RunsTableFragment
          }
        }
      }
    }
  }
  ${runsTableFragment}
`;
